module.exports = __webpack_public_path__ + "img/overheads-utilities.cd6b3399.svg";